var map = {
	"./2022_sponsor7_low.png": "EfmO",
	"./91logo_lightblue.png": "DZ4N",
	"./coaches/cert.jpg": "rODf",
	"./coaches/cindy.jpg": "d6xv",
	"./coaches/jun.jpg": "RrqC",
	"./coaches/luchi.jpg": "BefJ",
	"./coaches/quan.jpg": "j1RE",
	"./coaches/rico.jpg": "Vwo/",
	"./coaches/tina_wang.jpg": "voBD",
	"./favicon.ico": "43FW",
	"./hat2019.jpg": "n0XU",
	"./jersey2018.jpg": "yyNe",
	"./jersey2019-2.jpg": "AQVa",
	"./jersey2019.jpg": "/rCS",
	"./jersey2020.jpg": "A3j0",
	"./logo.png": "7Otq",
	"./logo1.png": "TrFT",
	"./logo1_white.png": "F3iA",
	"./race2018.jpg": "LxK0",
	"./race2019.jpg": "Vn6S",
	"./race2020-1.jpg": "QKNI",
	"./race2020-2.jpg": "/gjD",
	"./race2020.jpg": "7aek",
	"./rico.png": "henE",
	"./shopping/donation.jpg": "43+T",
	"./shopping/fee.jpg": "/P9V",
	"./shopping/merchandise.jpg": "KHot",
	"./sm_challenge.jpg": "AEYr",
	"./sm_living.jpg": "zN42",
	"./sm_running.jpg": "HSt+",
	"./sm_training.jpg": "EPRb",
	"./small_logo_white.png": "FDHq",
	"./sponsors_low.png": "Pwq4",
	"./stars/91BM-017-NiniWu.jpg": "aW6w",
	"./stars/91BM-018-GaozhiChen.jpg": "f6NE",
	"./stars/91BM-019-GangLi.jpg": "cLET",
	"./stars/91BM-020-GuopingYang.jpg": "zEVd",
	"./stars/91BM-021-DerekLai.jpg": "6nk7",
	"./stars/91BM-022-WeihuaLuo.jpg": "3hKx",
	"./stars/91BM-023-QuanJiang.jpg": "KCLW",
	"./stars/91BM-024-OliverNg.jpg": "e5Zz",
	"./stars/91BM-025-JuLin.jpg": "5FbR",
	"./stars/91BM-026-ZhiLi.jpg": "mE7I",
	"./stars/91BM-027-ThomasFan.jpg": "4Hqr",
	"./stars/91BM-028-WeiguoWu.jpg": "rwsU",
	"./stars/91BM-029-MeifangLiu.jpg": "3N8j",
	"./stars/91BM-030-StevenChiu.jpg": "68BC",
	"./stars/91BM-031-XujiaYu.jpg": "aR8c",
	"./stars/91BM-032-JingCao.jpg": "9+7Q",
	"./stars/91BM-033-LipengZeng.jpg": "UsvX",
	"./stars/91BM-034-FuguoYu.jpg": "osxi",
	"./stars/91BM-035-LidanZhu.jpg": "WPb8",
	"./stars/91BM-036-XiaofengLi.jpg": "BpY4",
	"./stars/91BM-037-MinZhou.jpg": "Hbsy",
	"./stars/91BM-038-FunuXin.jpg": "OX2q",
	"./stars/91BM-039-AaronSun.jpg": "lvj9",
	"./stars/91BM-040-ChunfangZhang.jpg": "WXSr",
	"./stars/91BM-041-WinieLai.jpg": "zuqC",
	"./stars/91BM-042-YanYin.jpg": "OXIi",
	"./stars/91BM-043-YanjianHuang.jpg": "HAzL",
	"./stars/91BM-044_PingChen.jpg": "yghX",
	"./stars/91BM-045-YueZhang.jpg": "NzGR",
	"./stars/91BM-046-YongleChen.jpg": "cV1g",
	"./stars/91BM-047-ClarenceHung.jpg": "ErcZ",
	"./stars/91BM-048-BensonGuo.jpg": "9bjc",
	"./stars/91BM-049-AllenZhao.jpg": "j/7o",
	"./stars/91BM-050-JimYu.jpg": "9vnm",
	"./stars/91BM-051-MaxCai.jpg": "NOG0",
	"./stars/91BM-052-HankDu.jpg": "epp1",
	"./stars/91BM-053-AnnieZhang.jpg": "iiIW",
	"./stars/91BM-054-JiajunLiu.jpg": "/+R9",
	"./stars/91BM-055-BenChan.jpg": "BDyq",
	"./stars/91BM-056-LuceZhang.jpg": "KXSJ",
	"./stars/91BM-057-YuanyuanAn.jpg": "k6q9",
	"./stars/91BM-058-HelenYan.jpg": "BYkb",
	"./stars/91BM-059-QiangjiangWang.jpg": "FW6W",
	"./stars/91BM-060-YonggangXiong.jpg": "M4y6",
	"./stars/91BM-061-MaxMeng.jpg": "v3WC",
	"./stars/91BM-062-StephenTsui.jpg": "IPyZ",
	"./stars/91BM-063-JinhaiChen.jpg": "NeQO",
	"./stars/91BM-064-MartinWei.jpg": "jIjE",
	"./stars/91BM-065-JingSun.jpg": "s359",
	"./stars/91BM-066-Norwin.jpg": "/vQ3",
	"./stars/91BM-067-Gavin.jpg": "4q3M",
	"./stars/91BM-068-LiuZhu.jpg": "Az9N",
	"./stars/91BM-069-JackZhang.jpg": "KBfr",
	"./stars/91BM-070-Morgan.jpg": "Tt8P",
	"./stars/91BM-071-Li.jpg": "uqDa",
	"./stars/91BM-072-Kitty.jpg": "iW2P",
	"./stars/91BM-073-GuanGuan.jpg": "uTRx",
	"./stars/andy.jpg": "OR3y",
	"./stars/bill.jpg": "+uuU",
	"./stars/carol.jpg": "mn7l",
	"./stars/daniel.jpg": "Gp81",
	"./stars/dong.jpg": "u52f",
	"./stars/guoxiangwang.jpg": "lKZF",
	"./stars/jessica.jpg": "aCmZ",
	"./stars/jim.jpg": "mNCg",
	"./stars/julie.jpg": "/gPG",
	"./stars/jun_star.jpg": "+eej",
	"./stars/kt.jpg": "8zcr",
	"./stars/laurel.jpg": "jCvC",
	"./stars/luchi.jpg": "t+Nk",
	"./stars/rico_star.jpg": "olTf",
	"./stars/rocky.jpg": "SPON",
	"./stars/sa.jpg": "dgfC",
	"./stars/six_star.png": "78UE",
	"./stars/tina.jpg": "gh8E",
	"./stars/wei.jpg": "QmSx",
	"./stars/yi.jpg": "sUBK",
	"./wechat2.png": "h+LZ",
	"./wmm/bill_huang.jpg": "nz6S",
	"./wmm/bill_huang_cert.jpg": "1Giy",
	"./wmm/derek_lai.jpg": "asA4",
	"./wmm/guoping_yang.jpg": "paK7",
	"./wmm/guoxiang_wang.jpg": "E+bb",
	"./wmm/guoxiang_wang_cert.jpg": "kLCv",
	"./wmm/nini_wu.jpg": "fp/2",
	"./wmm/nini_wu_cert.jpg": "EgjW",
	"./wmm/nuxin_fu.jpg": "dxC2",
	"./wmm/ping_chen.jpg": "Y0gb",
	"./wmm/quan_jiang.jpg": "jGqX",
	"./wmm/quan_jiang_2.jpg": "qFrY",
	"./wmm/stephen_chiu.jpg": "B0lX",
	"./wmm/winnie_lai.jpg": "JJjs",
	"./wmm/yi_xiao.jpg": "GO9L",
	"./wmm/yinghua_huang.jpg": "bONA",
	"./wmm/yonggang_xiong_cert.jpg": "N8pC",
	"./wmm/yue_zhang.jpg": "CyI3",
	"./wmm/yue_zhang_2.jpg": "M733",
	"./wmm/yuehui_zhang.jpg": "cvvX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0